import * as Workbench from './parts/Workbench/Workbench.js'

const main = async () => {
  await Workbench.startup({})
}

main()
